<x-shop-dialog (closeDialog)="cancel()">
  <header xHeader class="tw:px-16 tw:flex tw:flex-col tw:gap-16">
    <div class="tw:type-headline-default tw:text-content-default">Update Subscriptions?</div>
    <x-subscriber-pills [subscribers]="data.subscribers"></x-subscriber-pills>
    <div>
      You have selected a new default address. Do you want to use this address as default for your
      subscriptions as well?
    </div>
  </header>

  <div class="subscribers-section">
    @for (subscriber of data.subscribers; track subscriber.id) {
      <div class="subscriber-item">
        <mat-checkbox [formControl]="getSubscriberControl(subscriber.id)">
          {{ subscriber.subscriptionName }}
        </mat-checkbox>
      </div>
    }
  </div>

  <x-shop-dialog-actions>
    <button mat-flat-button color="primary" (click)="confirm()" i18-button="@@Common.Confirm">
      Continue
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
